import "./styles.modules.scss";
import secondaryComponents from "..";
import useJournalEntriesTable from "./useJournalEntriesTable";
import Images from "../../../assets/images";

const JournalEntriesTable = ({
  metaDetails,
  journalEntries,
  handleFetchJournalEntries = () => {},
  gotoPage = () => {},
}) => {
  const { instance } = useJournalEntriesTable({
    journalEntries,
    handleFetchJournalEntries,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <div className="journal-lines-table">
      <div className="journal-lines-table__content">
        <secondaryComponents.TableHelper
          getTableProps={getTableProps}
          getTableBodyProps={getTableBodyProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          hasAction={true}
        >
          <div className="text-center mt-5 mb-5">
            <img src={Images.expense2EmptyState} width="250px" alt="" />
            <h4 className="font-weight-semibold text-center mt-4">
              You have no journal entry
            </h4>
            <p className="text-center">
              Use the button above to create a journal entry. When you do, they
              would appear here.
            </p>
          </div>
        </secondaryComponents.TableHelper>

        {journalEntries?.length > 0 && (
          <div className="mt-auto">
            <secondaryComponents.Pagination
              totalPageNumber={metaDetails?.last_page}
              handlePageClick={(value) => gotoPage(value?.selected + 1)}
              currentPage={metaDetails?.current_page}
            />
          </div>
        )}
      </div>
      {/* add modal */}
    </div>
  );
};

export default JournalEntriesTable;
